import React from 'react';
import { Button } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Check } from 'lucide-react';

import { trackEvent } from '../../../../helpers/analytics';

export const PlaceholderNoSubscriptions = () => {
  const onClickBookDemo = () => {
    trackEvent('upsell:getro_for_companies_demo_click', { origin: 'api_keys_screen' });
    window.open('https://meetings.hubspot.com/laura-marks', '_blank');
  };

  return (
    <Box maxWidth="400px" mx="auto" mt="32px" mb="0">
      <Flex flexDirection="column" sx={{ gap: '24px' }}>
        <Text fontSize="22px" fontWeight="bold" color="text.dark">
          Supercharge your workflow with Getro’s API
        </Text>
        <Text>Connect your job board and contacts data with the tools your team already loves.</Text>
        <Flex flexDirection="column" sx={{ gap: '16px' }}>
          <Flex sx={{ color: 'purple.500', gap: '8px' }}>
            <Box mt="4px" as={Check} width="16px" height="16px" aria-hidden="true" flex="0 0 auto" />
            <Text color="text.dark">
              Access and sync your{' '}
              <Text as="span" fontWeight="semibold">
                job board and contacts data
              </Text>
            </Text>
          </Flex>
          <Flex sx={{ color: 'purple.500', gap: '8px' }}>
            <Box as={Check} width="16px" height="16px" aria-hidden="true" flex="0 0 auto" />
            <Text color="text.dark">
              Connect Getro to tools like Airtable, HubSpot, and Slack via{' '}
              <Text as="span" fontWeight="semibold">
                Zapier
              </Text>
            </Text>
          </Flex>
          <Flex sx={{ color: 'purple.500', gap: '8px' }}>
            <Box as={Check} width="16px" height="16px" aria-hidden="true" flex="0 0 auto" />
            <Text color="text.dark">
              Build{' '}
              <Text as="span" fontWeight="semibold">
                custom workflows and apps
              </Text>{' '}
              powered by your network data
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Button sx={{ width: '100%', marginTop: '40px', justifyContent: 'center' }} onClick={onClickBookDemo}>
        Book a demo
      </Button>
    </Box>
  );
};
